import { Button, Select, SelectOption } from "@rio-cloud/rio-uikit";
import { useNavigate } from "react-router";
import SchedulingSummary from "../schedulingSummary";
import { useSupportByOccurrence } from "../../../../../../hooks/useSupportByOccurrence";
import { Occurrence } from "../../../../../../models/occurrence";
import { typeSubjectOccorence } from "../../../../../../pages/support/constants";
import SupportItem from "./SupportItem";

interface Props {
  occurrence: Occurrence;
  persona?: "MANAGER" | "TOWER" | "CONSULTANT" | "PARTNERSHIP";
}

const subjectOptions: SelectOption[] = [
  { id: "", label: "Todos" },
  ...Object.entries(typeSubjectOccorence).map(([id, label]) => ({ id, label })),
];

const getPersonaBasePath = () => `/${window.location.pathname.split("/").filter(Boolean)[0] ?? ""}`;

const SupportTab = ({ occurrence, persona }: Props) => {
  const navigate = useNavigate();
  const {
    openOccurrences,
    finishedOccurrences,
    loading,
    searchTerm,
    setSearchTerm,
    subject,
    setSubject,
    responsible,
    setResponsible,
  } = useSupportByOccurrence(occurrence.id);

  const goToSupportDetails = (id: number | string) => {
    navigate(`${getPersonaBasePath()}/support/details?id=${id}`);
  };

  const goToNewSupportCall = () => {
    navigate(`${getPersonaBasePath()}/support/new-support-call?mainOccurrenceId=${occurrence.id}`);
  };

  return (
    <div>
      <div className="text-size-h4 margin-bottom-5">Suporte</div>
      <div className="text-color-gray margin-bottom-15">
        Crie e visualize suportes vinculados a esse chamado
      </div>

      <SchedulingSummary occurrence={occurrence} persona={persona} />

      <hr className="border-color-gray-light border-bottom-solid margin-bottom-20" />

      <div className="text-medium margin-bottom-10">Todos os suportes atribuídos a esse chamado</div>

      <Button bsStyle={Button.PRIMARY} iconName="rioglyph-plus" onClick={goToNewSupportCall} className="margin-bottom-15">
        Nova solicitação
      </Button>

      <input
        type="text"
        className="form-control margin-bottom-10"
        placeholder="Busque por nº de solicitação"
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
      />

      <div className="display-flex gap-10 margin-bottom-15">
        <div className="flex-1-1">
          <label className="text-size-12">Assunto</label>
          <Select
            id="supportSubjectFilter"
            placeholder="Todos"
            value={[subject]}
            options={subjectOptions}
            useFilter
            onChange={(selected) => setSubject(selected?.id ?? "")}
          />
        </div>
        <div className="flex-1-1">
          <label className="text-size-12">Responsável</label>
          <input
            type="text"
            className="form-control"
            value={responsible}
            onChange={(event) => setResponsible(event.target.value)}
          />
        </div>
      </div>

      {loading ? (
        <div className="text-center padding-20">Carregando...</div>
      ) : (
        <>
          <div className="text-medium margin-bottom-10">Em aberto</div>
          {openOccurrences.length === 0 && (
            <div className="text-color-gray text-size-12 margin-bottom-15">Nenhum suporte em aberto.</div>
          )}
          {openOccurrences.map((item) => (
            <SupportItem key={item.id} data={item} onClick={() => goToSupportDetails(item.id)} />
          ))}

          <hr className="border-color-gray-light border-bottom-solid margin-top-10 margin-bottom-15" />

          <div className="text-medium margin-bottom-10">Finalizados</div>
          {finishedOccurrences.length === 0 && (
            <div className="text-color-gray text-size-12">Nenhum suporte finalizado.</div>
          )}
          {finishedOccurrences.map((item) => (
            <SupportItem key={item.id} data={item} onClick={() => goToSupportDetails(item.id)} />
          ))}
        </>
      )}
    </div>
  );
};

export default SupportTab;
